<template lang="pug">

  //-
    - ENABLED
    - Usuário disponível como opção
    -

  .userItem(
    v-if="disabled === false"
    :class="{ 'selected': isSelected && isMultiSelectActive }"
    @click.stop.prevent="click(source)"
  )
    //- ENDPOINT (ADD USER TO SCALE)

    .item-content
      .item-content__user
        //- User image
        img(v-if="source.image" :src="source.image")
        //- Mock "image" with USER'S NAME OR E-MAIL first letter
        .imgplaceholder(v-else)
          | {{ (source.name || "Não informado")[0] }}
        span.secondColumn
          //- User name
          span.name {{ source.name || "[Não informado]" }}
          //- User e-mail
          span.email {{ source.email || "[Não informado]" }}
      .labelAndActionColumn
        //- User label
        .labels(v-if="source._label")
          span.label.me(v-if="source._label === 'ME'") Você
          span.label.recent(v-if="source._label === 'RECENT'") Recente
          span.label.blocked(v-if="source._label === 'BLOCKED'") Limite atingido
          span.label.blocked(v-if="source._label === 'REMOVE'") Remover
          span.label.recent(v-if="source._label === 'ADD'") Adicionar
        //- Checkbox
        .add-user-to-scale___selection-checkbox(v-if="isMultiSelectActive")
          v-checkbox(:input-value="isSelected" dense hide-details readonly color="primary")

  //-
    - DISABLED
    - Usuário indisponível como opção, pois o plano limitou a quantidade
    -

  //- .userItem.userItem--disabled(v-else-if="disabled === true")
  .userItem.userItem--disabled(v-else)

    //- .userItem.userItem--disabled(
      v-else-if="disabled === true"
      :class="{ 'hasTooltip': showBlockedHint }"
      @mouseenter="onHover"
      @mouseleave="onLeave"
      @click="onClick")

    //- .blockedHint.blockedHint--float(v-if="showBlockedHint")

      b
        i.mdi.mdi-alert
        | &nbsp;Plano limitado:

      //-b(style="color: darkorange")
        i.v-icon.notranslate.mdi.mdi-alert(aria-hidden="true")
        | &nbsp;Atenção:

      template(v-if="userSession.planOrigin === 'CUSTOM'")
        span(v-html="`Você está no ${userSession.planName.name} personalizado, mas consegue ver até ${userSession.userCapabilities.limiteUsuarios} usuário(s).&nbsp;`")
        span Por favor,&nbsp;
        a(:href="`https://api.whatsapp.com/send?phone=5513992061010&text=Olá, estou no ${userSession.planName.name} e não consigo selecionar todos os usuários para montar uma escala. Preciso de ajuda.`" target="_blank") converse com o nosso suporte

      template(v-else-if="userSession.planOrigin === 'COUPON'")
        span(v-html="`Você tem um cupom ativo e está no ${userSession.planName.name}, mas consegue ver até ${userSession.userCapabilities.limiteUsuarios} usuário(s).&nbsp;`")
        span Por favor,&nbsp;
        a(:href="`https://api.whatsapp.com/send?phone=5513992061010&text=Olá, estou no ${userSession.planName.name} e não consigo selecionar todos os usuários para montar uma escala. Preciso de ajuda.`" target="_blank") converse com o nosso suporte

      template(v-else-if="userSession.planOrigin === 'VINDI' && userSession.vindi.paymentStatus === 'paid'")
        span(v-html="`Você está no ${userSession.planName.name} e consegue ver até ${userSession.userCapabilities.limiteUsuarios} usuário(s).&nbsp;`")
        span Por favor,&nbsp;
        a(:href="`https://api.whatsapp.com/send?phone=5513992061010&text=Olá, estou no ${userSession.planName.name} e não consigo selecionar todos os usuários para montar uma escala. Preciso de ajuda.`" target="_blank") verifique a situação da sua assinatura com o nosso suporte

      template(v-else-if="userSession.planOrigin === 'VINDI' && userSession.vindi.paymentStatus !== 'paid'")
        span(v-html="`Você é assinante do ${userSession.planName.name}, mas ele não está ativo. Você consegue ver até ${userSession.userCapabilities.limiteUsuarios} usuário(s).&nbsp;`")
        span Por favor,&nbsp;
        a(:href="`https://api.whatsapp.com/send?phone=5513992061010&text=Olá, estou no ${userSession.planName.name} e não consigo selecionar todos os usuários para montar uma escala. Preciso de ajuda.`" target="_blank") verifique a situação da sua assinatura com o nosso suporte

      template(v-else)

        template(v-if="!!userSession.vindi === true")
          span(v-html="`Você assinou o ${userSession.vindi.planName.name}, mas ele expirou. Agora você está no ${userSession.planName.name} e consegue ver até ${userSession.userCapabilities.limiteUsuarios} usuário(s).&nbsp;`")
          span Por favor,&nbsp;
          a(:href="`https://api.whatsapp.com/send?phone=5513992061010&text=Olá, estou no ${userSession.vindi.planName.name} e não consigo selecionar todos os usuários para montar uma escala. Preciso de ajuda.`" target="_blank") verifique a situação da sua assinatura com o nosso suporte

        template(v-else)
          span(v-html="`Você está no ${userSession.planName.name}. Você consegue ver até ${userSession.userCapabilities.limiteUsuarios} usuário(s).&nbsp;`")
          span Por favor,&nbsp;
          a(:href="`https://api.whatsapp.com/send?phone=5513992061010&text=Olá, estou no ${userSession.planName.name} e não consigo selecionar todos os usuários para montar uma escala. Preciso de ajuda.`" target="_blank") converse com o nosso suporte

      span &nbsp;e saiba como ter acesso a mais usuários.

    //- ENDPOINT (ADD USER TO SCALE)

    .item-content
      .item-content__user
        //- User image
        img(v-if="source.image" :src="source.image")
        //- Mock "image" with USER'S NAME OR E-MAIL first letter
        .imgplaceholder(v-else)
          | {{ (source.name || "Não informado")[0] }}
        span.secondColumn
          //- User name
          span.name {{ source.name || "[Não informado]" }}
          //- User e-mail
          span.email {{ source.email || "[Não informado]" }}
      .labelAndActionColumn
        //- User label
        .labels(v-if="source._label")
          span.label.me(v-if="source._label === 'ME'") Você
          span.label.recent(v-if="source._label === 'RECENT'") Recente
          span.label.blocked(v-if="source._label === 'BLOCKED'") Limite atingido
          span.label.blocked(v-if="source._label === 'REMOVE'") Remover
          span.label.recent(v-if="source._label === 'ADD'") Adicionar

</template>

<script>

export default {
  name: 'AddUserToScaleUserListItem',

  props: {
    click: { type: Function, default () { return function () { } } },
    source: { type: Object, default () { return {} } }, // Answer
    userSession: { type: Object, default () { return {} } }, // Plano

    disabled: { type: Boolean, default () { return false } },
    isSelected: { type: Boolean, default: false },
    isMultiSelectActive: { type: Boolean, default: false },
  },

  data() {
    return {
      showBlockedHint: false,
    }
  },

  methods: {
    // Importante para o desktop
    onHover() {
      if (this.disabled) this.showBlockedHint = true
    },
    onLeave() {
      this.showBlockedHint = false
    },
    // Necessário para o mobile
    onClick() {
      if (this.disabled) this.showBlockedHint = !this.showBlockedHint
    }
  },
}

</script>

<style lang="scss" scoped>

  .item-content__user {
    position: relative;
    width: 100%; // Faz com que a caixa fique confinada a caixa pai e o text-overflow funcionará
    padding-left: 44px;
  }

  /* Tipografia */

  span.name,
  span.email {
    // display: block;
    display: inline-block;
    vertical-align: middle;
    width: 100%;
    max-width: 100%;

    /* Tuncar nomes/emails longos */
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  span.email {
    // color: #7183a6;
    color: seagreen;
    font-size: 13px;
    font-weight: 400;
  }

  span.name {
    display: inline-block;
    color: #1f2937;
    font-size: 14px;
    font-weight: 500;
    line-height: 18px;
  }

  /* Badges / Labels */

  .labels {
    // margin-top: 6px;
    display: flex;
    gap: 6px;
    flex-wrap: wrap;
  }

  span.label {
    display: inline-flex;
    align-items: center;
    height: 18px;
    padding: 0 8px !important;
    border-radius: 999px;
    font-size: 11px;
    line-height: 18px;
    font-weight: 700;
    letter-spacing: 0.2px;

    /* aparência "leve": fundo suave + borda */
    border: 1px solid transparent;

    &.me {
      color: #6a1b9a;
      background: rgba(156, 39, 176, 0.10);
      border-color: rgba(156, 39, 176, 0.18);
    }

    &.recent {
      color: #7a4b00;
      background: rgba(255, 152, 0, 0.14);
      border-color: rgba(255, 152, 0, 0.22);
    }

    &.blocked {
      color: #8b1a1a;
      background: rgba(205, 92, 92, 0.16);
      border-color: rgba(205, 92, 92, 0.26);
    }
  }

  /* Conteúdo */

  .item-content {
    box-sizing: border-box;
    position: relative;

    display: flex;
    align-items: center;
    width: 100%;
    padding-right: 110px;

    /* Tuncar nomes/emails longos */
    // min-width: 0; /* importante pro ellipsis funcionar */
  }

  /* Item */

  .userItem {
    transition: background-color 160ms ease, border-color 160ms ease, box-shadow 160ms ease, transform 160ms ease;
    cursor: pointer;

    z-index: 0;
    position: relative;

    width: 100%;
    padding: 0 12px;
    border-radius: 12px;

    border: 1px solid rgba(17, 24, 39, 0.10);
    background-color: #ffffff;

    font-size: 0;

    display: flex;
    align-items: center;
    justify-content: space-between;

    /* Avatar */

    img,
    .imgplaceholder {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      margin: auto 0;

      width: 34px;
      height: 34px;
      border-radius: 999px;
      flex: 0 0 34px;
    }

    img {
      object-fit: cover;
      border: 1px solid rgba(17, 24, 39, 0.10);
      background: #fff;
    }

    .imgplaceholder {
      display: inline-flex;
      align-items: center;
      justify-content: center;

      background: rgba(17, 24, 39, 0.06);
      border: 1px solid rgba(17, 24, 39, 0.10);
      color: rgba(17, 24, 39, 0.65);

      font-size: 12px;
      font-weight: 800;
      text-transform: uppercase;
    }

    /* Coluna de texto */

    span.secondColumn {
      display: block;
      min-width: 0;
      padding: 8px 0;
    }

    /* Hover leve */

    &:hover {
      border-color: rgba(25, 118, 210, 0.35);
      box-shadow: 0 6px 18px rgba(17, 24, 39, 0.06);
      transform: translateY(-1px);
    }

    /* Selected elegante */

    &.selected {
      border-color: rgba(25, 118, 210, 0.55);
      background: rgba(25, 118, 210, 0.06);
      box-shadow: 0 10px 24px rgba(25, 118, 210, 0.12);
    }

    /* Checkbox coluna */

    .add-user-to-scale___selection-checkbox {
      flex: 0 0 auto;
      display: flex;
      align-items: center;
    }

    /* Disabled */

    &.userItem--disabled {
      user-select: none;
      cursor: not-allowed;

      opacity: 0.72;
      background: rgba(17, 24, 39, 0.02);
      border-color: rgba(17, 24, 39, 0.08);
      box-shadow: none;
      transform: none !important;

      &:hover {
        border-color: rgba(17, 24, 39, 0.08);
        box-shadow: none;
        transform: none;
      }

      &.selected {
        background: rgba(17, 24, 39, 0.02);
        border-color: rgba(17, 24, 39, 0.08);
        box-shadow: none;
      }

      span.name { color: darkred; }
      span.email { color: #777777; }

      &.hasTooltip {
        z-index: 50; // maior que os outros itens
        opacity: 1;
      }
    }
  }

  .labelAndActionColumn {
    z-index: 1;
    position: absolute;
    right: 0;

    display: flex;
    align-items: center;
    justify-content: flex-end;
    width: 110px;
  }

</style>
